import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { InfoTooltip } from "components/Table";
import { body1SemiBoldStyles } from "shared";

import { CardProps } from "./types";

const Card = ({
    children,
    title,
    infoTooltipText,
    subtitle,
    headerContent,
    containerCustomStyle,
    headerCustomStyle,
    bodyCustomStyle
}: CardProps) => {
    const { textPlaceholder, white } = colors;

    return (
        <div
            css={css({
                background: white,
                borderRadius: "8px",
                boxShadow:
                    "0px 0px 2px 0px rgba(37, 42, 49, 0.16), 0px 1px 4px 0px rgba(37, 42, 49, 0.12)",
                ...containerCustomStyle
            })}
        >
            <div
                css={css({
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "24px 24px 16px 24px"
                })}
            >
                <div
                    css={css({
                        display: "flex",
                        ...headerCustomStyle
                    })}
                >
                    <h2
                        css={[
                            body1SemiBoldStyles,
                            {
                                "& > span": {
                                    color: textPlaceholder,
                                    fontSize: "14px",
                                    lineHeight: "16px",
                                    letterSpacing: "0.1px"
                                }
                            }
                        ]}
                    >
                        {title} {subtitle && <span>{subtitle}</span>}
                    </h2>

                    {infoTooltipText && (
                        <div
                            css={css({
                                display: "flex",
                                alignSelf: "flex-start",
                                alignItems: "center",
                                height: "20px",
                                marginLeft: "8px"
                            })}
                        >
                            <InfoTooltip title={infoTooltipText} />
                        </div>
                    )}
                </div>

                {headerContent}
            </div>

            <div
                css={css({
                    padding: "0 24px 24px",
                    ...bodyCustomStyle
                })}
            >
                {children}
            </div>
        </div>
    );
};

export { Card };
